import { render, staticRenderFns } from "./BatchSubmitReviewEventDialog.vue?vue&type=template&id=1bc81cf5&scoped=true"
import script from "./BatchSubmitReviewEventDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BatchSubmitReviewEventDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BatchSubmitReviewEventDialog.vue?vue&type=style&index=0&id=1bc81cf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc81cf5",
  null
  
)

/* custom blocks */
import block0 from "./BatchSubmitReviewEventDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ReviewStatusChip: require('/home/runner/work/assessment-service/assessment-service/frontend/components/review/StatusChip.vue').default})
